import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

export namespace ApiTaNt030 {

  // GET parameters
  export namespace Get {
    export interface Request {
      path: {
        noticeId: number
      }
    }

    export type Response = {
      body: string,
      questionnaireSymbol: string,
      buttonImageUrl: string
    }
  }

  // API Path
  const pathFormat: string = '/ta/notices/:noticeId'

  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {

    public get<R>(params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler:ApiResponseHandler<ResponseError, R>)
      : Promise<R | null> {

      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        body: '',
        questionnaireSymbol: '',
        buttonImageUrl: ''
      }
      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: ''
        }
      }

      const path: string = this.makePath(pathFormat, params.path)

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(path),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample)
    }
  }
}